<template>
  <v-card outlined color="">
    <v-img class="align-end" src="http://47.94.10.11/static/files/bar.gif" height="220">
      <v-card-title class="white--text">{{advtext}}</v-card-title>
    </v-img>
  </v-card>
</template>
<script>
export default{
  name:'Advbar',
  data(){
    return{
        
    }
  },
  props:{
    advtext:{
      type:String,
      default:'大连盛隆'
    }
  },
}
</script>
<style scoped>

</style>
